
// src/app/form-prop-contributors.ts
import { ePropType, FormProp, FormPropList } from '@abp/ng.components/extensible';
import { Validators } from '@angular/forms';
import { SaasTenantDto, TenantActivationState} from '@volo/abp.ng.saas/proxy';
import { eTenantManagementComponents, TenantManagementEntityPropContributors } from '@abp/ng.tenant-management';
import { DEFAULT_TENANTS_ENTITY_PROPS, eSaasComponents, SaasEditFormPropContributors, TenantsComponent  } from '@volo/abp.ng.saas';
import { AbstractControl, ValidatorFn } from '@angular/forms';
import { minDateTodayValidator } from "./tenant-form-props";
import { of } from 'rxjs';
import { LocalizationService } from '@abp/ng.core';

const endDateProp= new FormProp<SaasTenantDto>({
  type: ePropType.DateTime,
  name: 'activationEndDate',
  displayName: 'Saas::DisplayName:ActivationEndDate',
  id: 'activation-end-date',
  visible: data => {
    const { tenantForm } = data.getInjected(TenantsComponent);
    return (
      tenantForm.get('activationState').value === TenantActivationState.ActiveWithLimitedTime
    );
  },
  validators: () => [minDateTodayValidator()]
});

const editionIdProp= new FormProp<SaasTenantDto>({
    type: ePropType.String,
    name: 'editionId',
    displayName: 'Saas::Edition',
    id: 'edition',
    disabled: data => {
      const editionEndDate = data.record.editionEndDateUtc;
      const subscriptionExpired =
        editionEndDate && new Date(editionEndDate).getTime() < new Date().getTime();
      return subscriptionExpired;
    },
    visible: data => false, // Campo sempre invisível
    options: data => {
      const editions = data.getInjected(TenantsComponent).editions;
      const localization = data.getInjected(LocalizationService);
      const emptyOption = {
        value: null,
        key: localization.instant('AbpUi::NotAssigned'),
      };

      return of([
        emptyOption,
        ...editions.map(edition => ({
          key: edition.displayName,
          value: edition.id,
        })),
      ]);
    },

  validators: () => [minDateTodayValidator()]
});

export function endDateEditPropContributor(propList: FormPropList<SaasTenantDto>) {
  //Substitui o campo EndDate
  const index = propList.findIndex(prop => prop.value.name === 'activationEndDate');
  propList.dropByIndex(index);
  propList.addByIndex(endDateProp, index);

  //Remove o campo de edição do formulário de criação
  const editionIndex = propList.findIndex(prop => prop.value.name === 'editionId');
  propList.dropByIndex(editionIndex);
  propList.addByIndex(editionIdProp, editionIndex)
}

export const endDateEditPropsContributors: SaasEditFormPropContributors= {
  // enum indicates the page to add contributors to
  [eSaasComponents.Tenants]: [
    endDateEditPropContributor,
    // You can add more contributors here
  ],
};



